<template>
  <ReportLayoutBase v-if="isReportInitialized">
    <div :class="{ 'report-layout__selectors': true, 'report-layout__selectors--journey-page': !isJourneyPage }">
      <DeviceCategorySelector v-model="deviceCategory" />
      <PeriodSelector v-model:preset="selectedPreset" v-model="selectedPeriod" />
    </div>
    <hr v-if="isJourneyPage" class="selector-separator" />
    <RouterView :period="selectedPeriod" :preset="selectedPreset" :device-category="deviceCategory" />
  </ReportLayoutBase>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import DeviceCategorySelector from "@host/components/condition-selectors/DeviceCategorySelector.vue";
import PeriodSelector from "@host/components/condition-selectors/PeriodSelector.vue";
import { useReport } from "@host/composables/useReport";
import ReportLayoutBase from "./_ReportLayoutBase.vue";

const route = useRoute();

const isJourneyPage = computed(() => route?.name === "Journey");

const { deviceCategory, selectedPeriod, selectedPreset, isReportInitialized } = useReport();
</script>

<style lang="scss">
.report-layout__selectors {
  display: flex;
  height: 64px;
  width: auto;
  align-items: center;
  padding: 0 20px;

  &--journey-page {
    box-shadow: 0px 1px 4px rgba($colorGray1000, 0.08);
  }
}

.selector-separator {
  margin: 0 20px;
  height: 1px;
  background-color: $colorBase500;
  border: none;
}
</style>
